let reload_data_table = (actionData) => {
    window.DataTables = window.DataTables || {};
    if (window.DataTables.hasOwnProperty(actionData.dataTableId)) {
        window.DataTables[actionData.dataTableId].ajax.reload(null, false);
    }
};
export default reload_data_table;
